export default "__VITE_ASSET__Dx6sUl5T__"